import axios from 'axios';
import OAuth from "../oauth";
export default (function () {
  // console.log(env('API_URL'))
  var oauth = new OAuth();
  var token = oauth.getAuthHeader();
  return axios.create({
    baseURL: env('API_URL'),
    headers: {
      'Authorization': token
    }
  });
});